let token = '';

function getToken(): string {
  const tokenMeta = document.querySelector('meta[name="notify-jwt"]');
  if (tokenMeta) {
    token = tokenMeta.getAttribute('content') || '';
    tokenMeta.parentNode?.removeChild(tokenMeta);
  }

  return token;
}

export const NotifyJWTHelper = {
  getToken
};
